import { h } from 'preact';

export const UsersIcon = () => (
  <svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25 16H9C10.3644 11.379 12.0173 9.82491 17 9.33333C21.3844 9.69949 23.2629 10.9727 25 16Z" fill="#97AA5C" stroke="white" stroke-width="0.5" />
    <path d="M17 16H1C2.36439 11.379 4.01727 9.82491 9 9.33333C13.3844 9.69949 15.2629 10.9727 17 16Z" fill="#97AA5C" stroke="white" stroke-width="0.5" />
    <circle cx="17.0013" cy="5.33333" r="5.08333" fill="#97AA5C" stroke="white" stroke-width="0.5" />
    <circle cx="9.0013" cy="5.33333" r="5.08333" fill="#97AA5C" stroke="white" stroke-width="0.5" />
  </svg>
);